/* CloudFortifiedAppTooltipV2.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "._18u01eps{margin-left:var(--ds-space-100)}";
const _11 = "._19pkidpf{margin-top:0}";
const _10 = "._4cvr1h6o{align-items:center}";
const _9 = "._2lx2vrvc{flex-direction:row}";
const _8 = "._1p571eps{row-gap:var(--ds-space-100)}";
const _7 = "._2lx21bp4{flex-direction:column}";
const _6 = "._1e0c1txw{display:flex}";
const _5 = "._otyrxjmg{margin-bottom:var(--ds-space-200)}";
const _4 = "._19pkxjmg{margin-top:var(--ds-space-200)}";
const _3 = "._k48pni7l{font-weight:600}";
const _2 = "._1e0c1nu9{display:inline}";
import { BodySmall, LinkWithIcon } from '@atlassian/mpac-primitives';
import React from 'react';
import { TEST_IDS } from '../../primitives/testIds';
import CloudFortifiedReliabilityIcon from '../CloudFortifiedReliabilityIcon';
import CloudFortifiedSupportIcon from '../CloudFortifiedSupportIcon';
import CloudSecurityParticipantIcon from '../CloudSecurityParticipantIcon';
const _ = "._p12f1tad{max-width:21.25rem}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_p12f1tad", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const BoldText = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1nu9 _k48pni7l", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  BoldText.displayName = 'BoldText';
}
const DetailsContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _5, _6, _7, _8]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkxjmg _otyrxjmg _1e0c1txw _2lx21bp4 _1p571eps", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  DetailsContainer.displayName = 'DetailsContainer';
}
const DetailsRow = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_6, _9, _10]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx2vrvc _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  DetailsRow.displayName = 'DetailsRow';
}
const DetailsText = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_11, _12]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkidpf _18u01eps", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  DetailsText.displayName = 'DetailsText';
}
const CloudFortifiedAppTooltipV2 = _ref6 => {
  let {
    onViewDetailsClick,
    faqPageLink
  } = _ref6;
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": TEST_IDS.CLOUD_FORTIFIED_TOOLTIP_V2
  }, /*#__PURE__*/React.createElement(BodySmall, null, /*#__PURE__*/React.createElement(BoldText, null, "Cloud Fortified"), " apps offer additional security, reliability, and support through:"), /*#__PURE__*/React.createElement(DetailsContainer, null, /*#__PURE__*/React.createElement(DetailsRow, null, /*#__PURE__*/React.createElement(CloudSecurityParticipantIcon, {
    label: "Cloud Security Participant Badge",
    size: "medium",
    primaryColor: "var(--ds-icon)"
  }), /*#__PURE__*/React.createElement(DetailsText, null, "Cloud security participation")), /*#__PURE__*/React.createElement(DetailsRow, null, /*#__PURE__*/React.createElement(CloudFortifiedReliabilityIcon, {
    label: "Cloud Fortified Reliability badge"
  }), /*#__PURE__*/React.createElement(DetailsText, null, "Timely reliability checks")), /*#__PURE__*/React.createElement(DetailsRow, null, /*#__PURE__*/React.createElement(CloudFortifiedSupportIcon, {
    label: "Cloud Fortified Support badge"
  }), /*#__PURE__*/React.createElement(DetailsText, null, "24hr support response time and more"))), /*#__PURE__*/React.createElement(LinkWithIcon, {
    type: "external",
    size: "small",
    href: faqPageLink,
    onClick: onViewDetailsClick
  }, "More details"));
};
export default CloudFortifiedAppTooltipV2;